import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { AppContext } from 'shared/AppContext';
import defaultColors from './colors';
import defaultFonts from './fonts';

const PitPayThemeProvider = ({
  children,
  theme,
  primaryColor: _primaryColor,
}) => {
  const context = useContext(AppContext);
  const appThemeName = context?.state?.theme;
  const themeName = theme?.name || appThemeName || 'dark';

  return (
    <ThemeProvider
      theme={{
        name: themeName,
        colors: {
          ...defaultColors,
          ...theme.colors,
        },
        fonts: {
          ...defaultFonts,
          ...theme.fonts,
        },
      }}
    >
      {children}
    </ThemeProvider>
  );
};

PitPayThemeProvider.propTypes = {
  children: PropTypes.any.isRequired,
  theme: PropTypes.shape({
    name: PropTypes.oneOf(['light', 'dark']),
    colors: PropTypes.object,
    fonts: PropTypes.object,
  }),
  primaryColor: PropTypes.string,
};

PitPayThemeProvider.defaultProps = {
  theme: {
    name: 'dark',
    colors: {},
    fonts: {},
  },
  primaryColor: null,
};

export default PitPayThemeProvider;
